module.exports = __webpack_public_path__ + "img/illustration-404.e9f7f688.svg";